<template lang="html">
  <div class="jobs"
  data-aos="fade-left"
  data-aos-easing="ease-out-quad"
  data-aos-duration="250">
    <div class="heading">
      <h1>Experience</h1>
      <hr>
    </div>
    <div class="text-experience" v-for="info in info" :key="index">
      <div class="job-overview" >
        <div class="job-image">
          <img class="text-center" v-bind:src="info.image" alt="Haider Ahmed worked at Sun Life, RBC Amplify, IBM Canada, Eli Lilly">
        </div>
        <div class="job-details">
          <h2>{{info.company}}</h2>
          <p class="text-left"> {{info.description}} </p>
          <!--CREATE LIST AND LOOP -->
          <ul class="text-left">
            <li v-for="detail in info.details">{{ detail }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lilly from "../assets/previous-internships/haider_ahmed_eli_lilly-min.jpg"
import ibm2 from "../assets/previous-internships/haider_ahmed_ibm1-min.jpg"
import ibm1 from "../assets/previous-internships/haider_ahmed_ibm2-min.jpg"
import sunlife from "../assets/previous-internships/sun-life-ignition-studio.png"
import rbc from "../assets/previous-internships/rbc_amplify-min.jpg"
import loblaw from "../assets/previousWork/HQMH3196.jpeg"


export default {
  name: 'jobs',
  data: function () {
    return {
      info: [
        {
        company: 'Loblaw Innovation - Full Stack Developer',
        description: '',
        image: loblaw,
        details: [
                  "Lead the creation of in-house prototypes around emerging technologies and created standardized components and hosting for quick project turnaround whenever new tech and ideas came down the pipeline.",
                  "Lead the development of the R&D space , managing all aspects including architecture drawings, network installation and construction of the space. The R&D Lab will allow Loblaw to be agile and test new technologies in a store-like enclosed sandbox environment.",
                  "Pivoted scope during Covid-19 lockdowns to provide businesses with technologies such as online booking, in-store traffic count and virtual makeup/cosmetics try-on to lower the impact of new Covid rules.",
                  "Provided cloud expertise to successfully migrate 3TB of highly sensitive data safely and securely using Azure",
                  ],
      },
        {
        company: 'RBC Amplify - Software Developer',
        description: 'Collaborated with a team of data scientist, developer and business analyst at RBC \'s in-house tech incubator, RBC Amplify.',
        image: rbc,
        details: ["Collaborated with a team of data scientists and designers to create a prototype of a platform that would facilitate communication between Capital Markets and I&TS business units.",
                  "Gained an understanding of internal processes and systems to create a solution that would expedite the information delivery, resulting in faster transactions.",
                  "Found technological deficiencies and found solutions that could save the business units $5M in labour costs",
                  "Created a prototype of a client-facing solution using Node.js and Vue.js which connected to internal APIs which displayed transactions and their details."],
      },{
        company: 'Sun Life Financial - IT Strategy Analyst',
        description: 'Supported key ES processes of Executive Reporting and ES Strategic Plan. Also involved in coordinating the ES Balanced ScoreCard and ES Service Review processes. ',
        image: sunlife,
        details: ["Developed a community on Salesforce using the Lightning App Builder for document and knowledge management.",
                  "Created a dynamic Tableau dashboard using the finance data available which revealed real insights for the senior executives.",
                  "Assisted with the planning, data collection, and preparation of executive and business partner reports.",
                ],
      },{
        company: 'IBM Canada (Cognos/Watson Analytics - Business Analytics) - Software Developer',
        description: 'Used multiple web development technologies to develop and test different segments of IBM Watson Analytics. ',
        image: ibm1,
        details: ["Moved old web technologies to the React framework for faster performance and component-based design that reduced the amount of redundant work.",
                  "Helped with the creation of React.js app toolkit that would be used by the developers to unify the different components of the platform.",
                  "Developed responsive components for the Watson analytics platform using the in-house SCSS framework.",
                  "Skills: JS, Docker, React, SCSS, React Router, Async."],
      },{
        company: 'IBM Canada (Watson Analytics) - Front End Developer',
        description: 'Used modern web development technologies like React.js and webpack to develop and redesign different segments of IBM Watson Analytics.',
        image: ibm2,
        details: ["Web Development: Responsible for developing responsive segments for the Watson analytics platform. Used Wireframes to follow design requirements for both mobile and desktop devices.",
                  "Site Responsiveness: Worked with designers to specify site functionality, features and styling for both mobile and desktop devices.",
                  "Clean code: Followed team’s guidelines for writing code and using global variables.",
                  "Testing: Wrote test cases and helped debug errors to pass the testing phase."
                ],
      },{
        company: 'Eli Lilly Canada - Business Analyst',
        description: 'Responsible for assessing UI/UX of Lilly Pro, an online platform for HCPs, using Analytics data and preparing solutions to improve user experience',
        image: lilly,
        details: ["UX Management: Used analytics data and UX principles to find flaws in UI that could be fixed to improve the user experience.",
                  "SEO: Evaluated the meta tags and content of different affiliated websites to find strategies that increase the traffic generated through organic searches.",
                  "SEM: Planned SEM strategies with the Digital team in order get the best ROI and the most conversions for the given budget.",
                  "Analytics and visualization: Used Tableau and MS Excel to create analytics reports for the affiliated websites that gave insights on user behaviour and activity patterns and their relevance to the real world as to why certain events took place."
                ],
      }],
      image: 'https://haiderahmed.ca/haider_ahmed_eli_lilly-min.jpg'
    }
  }
}
</script>

<style lang="scss">
.jobs {
  padding: 30px 0;
  text-align: left;
  .heading {
    text-align: center;
  }
}

.text-experience{
  width: 100%;

  

  .companies {
    display: grid;
    grid-template-columns: 150px 150px 150px 150px 150px;
    text-align: center;
    margin-top: 20px;

    a {
      text-decoration: none;
      transition: 0.3s all;
      padding: 5px;
      border-radius: 50px;

        &:hover {
          background: rgba(63, 81, 181, 0.5);
          color: white;
        }

        &:focus {
          background: rgb(63, 81, 181);
          color: white;
        }

        &:active {
          background: rgb(63, 81, 181);
          color: white;
        }

        &:visited {
          background: rgb(63, 81, 181);
        }


    }
  }
}

.job-overview {
  display: grid;
  grid-template-columns: 40% 60%;
  grid-gap: 50px;
  padding: 30px;
  


 .job-details {

   h2 {
     text-align: left;
   }
 }
}

@media only screen and (max-width: 1250px) {
  .job-overview {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 10px;
    padding: 0px;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 80%; 
    }

   .job-details {

     h2 {
       text-align: center;
     }
   }
 }
}

</style>
